import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const result = await login(email, password);
    
    if (result.success) {
      toast.success('¡Bienvenido de vuelta!');
      navigate('/dashboard');
    } else {
      toast.error(result.error);
    }
    
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#F5F5F0' }}>
      <div className="w-full max-w-md">
        <div className="bg-white border border-border shadow-sm rounded-sm p-8" data-testid="login-form">
          <Link to="/" className="block mb-8">
            <div className="flex flex-col items-center gap-3">
              <img src="/assets/logo.png" alt="contractcheck360" className="h-16 w-auto" />
              <span className="text-2xl brand-name" style={{ color: '#1A4D2E' }}>
                contractcheck360
              </span>
            </div>
          </Link>
          
          <h2 className="text-2xl font-semibold mb-2" style={{ fontFamily: 'Merriweather, serif' }}>
            Iniciar Sesión
          </h2>
          <p className="text-base mb-6" style={{ color: '#64748B' }}>
            Ingresa a tu cuenta
          </p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-2" style={{ color: '#0F172A' }}>
                Correo Electrónico
              </label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="h-12 bg-white border border-input focus:border-primary focus:ring-1 focus:ring-primary rounded-sm transition-all"
                placeholder="tu@email.com"
                data-testid="login-email-input"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-2" style={{ color: '#0F172A' }}>
                Contraseña
              </label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={8}
                className="h-12 bg-white border border-input focus:border-primary focus:ring-1 focus:ring-primary rounded-sm transition-all"
                placeholder="••••••••"
                data-testid="login-password-input"
              />
            </div>

            <div className="text-right">
              <Link to="/forgot-password" className="text-sm hover:underline" style={{ color: '#1A4D2E' }}>
                ¿Olvidaste tu contraseña?
              </Link>
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-primary text-primary-foreground hover:bg-primary/90 h-11 rounded-sm font-medium"
              style={{ backgroundColor: '#1A4D2E' }}
              data-testid="login-submit-btn"
            >
              {loading ? 'Iniciando...' : 'Iniciar Sesión'}
            </Button>
          </form>

          <p className="text-center text-sm mt-6" style={{ color: '#64748B' }}>
            ¿No tienes cuenta?{' '}
            <Link to="/register" className="font-medium hover:underline" style={{ color: '#1A4D2E' }}>
              Regístrate aquí
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;